import { defineStore } from "pinia";

/** 打开登录弹窗时的可选参数 */
export interface LoginDialogOpenOptions {
  /** 登录成功后跳转的业务路径 */
  redirectPath?: string;
  /** 是否因会话失效触发（登录成功后刷新页面） */
  sessionExpired?: boolean;
}

/**
 * 全局登录弹窗状态。落地页/登录页路由取消后，统一用弹窗完成登录。
 */
export const useLoginDialogStore = defineStore("loginDialog", {
  state: () => ({
    /** 弹窗是否可见 */
    visible: false,
    /** 登录成功后的回跳路径 */
    redirectPath: "",
    /** 是否为会话失效后的重新登录 */
    sessionExpired: false,
  }),
  actions: {
    /**
     * 打开登录弹窗。
     */
    open(options?: LoginDialogOpenOptions) {
      this.redirectPath = options?.redirectPath || "";
      this.sessionExpired = Boolean(options?.sessionExpired);
      this.visible = true;
    },
    /**
     * 关闭登录弹窗并清空一次性标记。
     */
    close() {
      this.visible = false;
      this.sessionExpired = false;
    },
  },
});
